import { IonPage, IonRouterOutlet } from '@ionic/react';
import { Route } from 'react-router';
import NewsList from './NewsList';
import NewsDetailsPage from './NewsDetails';

const NewsRouting: React.FC = () => {
  return (
    <IonPage>
      <IonRouterOutlet>
        <Route
          exact
          path='/news/:announcementId'
          component={NewsDetailsPage}
        ></Route>
        <Route exact path='/news'>
          <NewsList />
        </Route>
      </IonRouterOutlet>
    </IonPage>
  );
};
export default NewsRouting;
